import React, { useState } from 'react'

const versionPage = () => {
  const version = '1.4.0'

  return (
    <h3>
      version: {version}
    </h3>
  )
}

export default versionPage
